module.exports = __webpack_public_path__ + "img/1F3F3-FE0F.191fa0c8.svg";